
import { keyRisks } from '../../../mocks/roadmapData';

const severityConfig = {
  high: { label: '높음', bg: 'bg-rose-100', text: 'text-rose-700', dot: 'bg-rose-500' },
  medium: { label: '중간', bg: 'bg-amber-100', text: 'text-amber-700', dot: 'bg-amber-500' },
  low: { label: '낮음', bg: 'bg-teal-100', text: 'text-teal-700', dot: 'bg-teal-500' },
};

export default function RiskDashboard() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">리스크 관리 대시보드</h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto">
            프로젝트 전 과정에서 발생 가능한 주요 리스크와 대응 전략을 종합적으로 관리합니다.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {keyRisks.map((risk, index) => {
            const sev = severityConfig[risk.severity as keyof typeof severityConfig];
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 border border-gray-100 hover:shadow-lg transition-all cursor-default group"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="w-12 h-12 bg-gray-50 rounded-xl flex items-center justify-center group-hover:bg-gray-100 transition-colors">
                    <i className={`${risk.icon} text-2xl text-gray-700`}></i>
                  </div>
                  <span className={`px-2.5 py-1 ${sev.bg} ${sev.text} text-xs font-bold rounded-full whitespace-nowrap`}>
                    {sev.label}
                  </span>
                </div>
                <h4 className="text-base font-bold text-gray-900 mb-2">{risk.title}</h4>
                <div className="flex items-center gap-4 mb-4">
                  <div className="flex items-center gap-1.5">
                    <i className="ri-error-warning-line text-sm text-gray-400"></i>
                    <span className="text-sm text-gray-500">영향: <strong className="text-gray-700">{risk.impact}</strong></span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <i className="ri-bar-chart-line text-sm text-gray-400"></i>
                    <span className="text-sm text-gray-500">확률: <strong className="text-gray-700">{risk.probability}</strong></span>
                  </div>
                </div>
                <div className="bg-teal-50 rounded-lg p-3 border border-teal-100">
                  <div className="text-xs font-bold text-teal-700 mb-1">
                    <i className="ri-shield-check-line mr-1"></i>대응 전략
                  </div>
                  <p className="text-xs text-teal-600 leading-relaxed">{risk.mitigation}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
